var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconAboutUs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 2.45031C11.45 1.86031 12.58 1.86031 13.26 2.45031L14.84 3.80031C15.14 4.05031 15.71 4.26031 16.11 4.26031H17.81C18.87 4.26031 19.74 5.13031 19.74 6.19031V7.89031C19.74 8.29031 19.95 8.85031 20.2 9.15031L21.55 10.7303C22.14 11.4303 22.14 12.5603 21.55 13.2403L20.2 14.8203C19.95 15.1203 19.74 15.6803 19.74 16.0803V17.7803C19.74 18.8403 18.87 19.7103 17.81 19.7103H16.11C15.71 19.7103 15.15 19.9203 14.85 20.1703L13.27 21.5203C12.57 22.1103 11.44 22.1103 10.76 21.5203L9.18001 20.1703C8.88001 19.9203 8.31 19.7103 7.92 19.7103H6.17C5.11 19.7103 4.24 18.8403 4.24 17.7803V16.0703C4.24 15.6803 4.04 15.1103 3.79 14.8203L2.44 13.2303C1.86 12.5403 1.86 11.4203 2.44 10.7303L3.79 9.14031C4.04 8.84031 4.24 8.28031 4.24 7.89031V6.20031C4.24 5.14031 5.11 4.27031 6.17 4.27031H7.9C8.3 4.27031 8.86 4.06031 9.16 3.81031L10.75 2.45031Z",
    stroke: "#A6B1BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.13086V12.9609",
    stroke: "#A6B1BB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9945 16H12.0035",
    stroke: "#A6B1BB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAboutUs);
export default __webpack_public_path__ + "static/media/iconAboutUs.ab3c3433d32d388a369d131875e51000.svg";
export { ForwardRef as ReactComponent };